import React, { useState } from 'react'
import { BackButton } from 'src/editor/shared/components/back-button'
import { SettingsMenuButton } from 'src/editor/shared/components/settings-menu-button'
import { twMerge } from 'tailwind-merge'

export interface SettingsNestedMenuProps {
  className?: string
  withHorizontalLine?: boolean
  menuButtonLabel: React.ReactNode
  menuButtonIcon?: () => React.ReactNode
  menuButtonClassName?: string
  menuTitle: string
  children: React.ReactNode
  isOpen?: boolean
  onClose?: () => void
}

export const SettingsNestedMenu = ({
  className,
  withHorizontalLine,
  menuButtonLabel,
  menuTitle,
  children,
  menuButtonClassName,
  menuButtonIcon,
  isOpen: isOpenFromProps,
  onClose,
}: SettingsNestedMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onBack = () => {
    setIsOpen(false)
    onClose?.()
  }
  return (
    <div
      className={twMerge(
        'mt-4',
        withHorizontalLine && 'border-0.5 border-border200 border-t pt-3',
        className,
      )}
    >
      <SettingsMenuButton
        className={menuButtonClassName}
        onClick={() => setIsOpen(true)}
        icon={menuButtonIcon}
      >
        {menuButtonLabel}
      </SettingsMenuButton>
      {(isOpenFromProps ?? isOpen) && (
        <div className="absolute inset-0 z-50 overflow-y-auto border-border200 border-r bg-bgPrimaryBase">
          <div className="m-[var(--sidebar-padding)]">
            <BackButton className="mb-6!" onClick={onBack} />
            <div className="mb-9 text-heading-4">{menuTitle}</div>
            {children}
          </div>
        </div>
      )}
    </div>
  )
}
